import styled from 'styled-components';

import { Grid } from '@breathelife/mui';

export const SignaturesContainer = styled(Grid)`
  display: flex;
  flex-wrap: wrap;
`;
